import type { Placeholders } from 'utils/fetchPlaceholders.ts';

export type ProductDetailsPlaceholders = ReturnType<
	typeof getProductDetailsPlaceholders
>;

export const getProductDetailsPlaceholders = (placeholders: Placeholders) => {
	return {
		...placeholders,
		pdpSku: placeholders.pdpSku || 'SKU',
		pdpProductDetails: placeholders.pdpProductDetails || 'Details',
		pdpCustomContactUs: placeholders.pdpCustomContactUs || 'Contact Us',
		pdpCustomRequestDemo: placeholders.pdpCustomRequestDemo || 'Request Demo',
		pdpCustomRequestQuote:
			placeholders.pdpCustomRequestQuote || 'Request Quote',
		pdpProductImage:
			placeholders.pdpProductImage ||
			'View larger image: {product} {key} of {total}',
	};
};
